import { getWindow } from './general';
export var builderTrendHostName = function () {
    var _a, _b;
    var btHostNameCheck = ((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location.host.includes('hd-qa71')) ||
        ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.location.host.includes('hd-qa74'));
    if (btHostNameCheck) {
        return 'arch.buildertrend.net';
    }
    return 'buildertrend.net';
};
export var integrationMessageHelper = {
    BT_LINK_ERR_001: 'BT_LINK_ERR_001',
    BT_LINK_ERR_002: 'BT_LINK_ERR_002',
    BT_LINK_ERR_003: 'BT_LINK_ERR_003',
    BT_LINK_ERR_004: 'BT_LINK_ERR_004',
    BT_LINK_ERR_005: 'BT_LINK_ERR_005',
    BT_LINK_ERR_006: 'BT_LINK_ERR_006',
    BT_LINK_ERR_007: 'BT_LINK_ERR_007',
    BT_LINK_ERR_008: 'BT_LINK_ERR_008',
    BT_LINK_ERR_009: 'BT_LINK_ERR_009',
    BT_LINK_ERR_010: 'BT_LINK_ERR_010',
    BT_LINK_ERR_011: 'BT_LINK_ERR_011',
    SVOC_ERR_500: 'BT_LINK_ERR_008',
    LINKED_SUCCESSFULLY: 'LINKED_SUCCESSFULLY',
};
export var integrationLinkErrorMessageHelper = {
    BT_LINK_ERR_004: 'This user has already linked their Home Depot and Buildertrend accounts. Please check which accounts you want to connect.',
    BT_LINK_ERR_006: 'This customer has already linked their Home Depot and Buildertrend accounts. Please check which accounts you want to connect.',
    BT_LINK_ERR_011: 'We cannot link your Pro Xtra account to Buildertrend. You must be an account admin within Buildertrend to link accounts.',
    DEFAULT: 'We’re sorry, there was a temporary technical error linking accounts. Please close this window and retry by clicking Link Buildertrend again or contact customer support if you continue to receive this error.',
};
export var getBTLinkParams = function (searchUrl) {
    if (searchUrl) {
        var urlParams = new URLSearchParams(searchUrl);
        return {
            experience: urlParams.get('experience'),
            code: urlParams.get('code'),
            state: urlParams.get('state'),
            originatedPage: urlParams.get('originatedPage'),
        };
    }
    return {
        experience: '',
        code: '',
        state: '',
        originatedPage: '',
    };
};
export var clearQuaryParamsAndReload = function () {
    var _a, _b;
    var locaitonCheck = ((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.hostname) || '';
    var urlParams = new URLSearchParams(locaitonCheck);
    urlParams.delete('code');
    urlParams.delete('state');
};
